import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { Avatar } from 'primeng/avatar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePickerModule } from 'primeng/datepicker';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { FieldsetModule } from 'primeng/fieldset';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { Skeleton, SkeletonModule } from 'primeng/skeleton';
import { SplitButton, SplitButtonModule } from 'primeng/splitbutton';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TreeTableModule } from 'primeng/treetable';
import { ServerSearchDirective } from '@card-software/nexus-utilities';

const primeNG = [
  ServerSearchDirective,
  SplitButton,
  SplitButtonModule,
  AccordionModule,
  AutoComplete,
  AutoCompleteModule,
  Avatar,
  BreadcrumbModule,
  ButtonModule,
  ConfirmDialogModule,
  CalendarModule,
  CardModule,
  CheckboxModule,
  DatePickerModule,
  DividerModule,
  DragDropModule,
  IconFieldModule,
  ToggleSwitchModule,
  InputGroupAddonModule,
  InputGroupModule,
  InputIconModule,
  InputNumberModule,
  InputTextModule,
  MessageModule,
  MultiSelectModule,
  OrderListModule,
  FieldsetModule,
  PanelModule,
  PaginatorModule,
  ProgressBarModule,
  SelectButtonModule,
  SelectModule,
  Skeleton,
  SkeletonModule,
  TableModule,
  TagModule,
  TimelineModule,
  ToastModule,
  ToggleButtonModule,
  TreeTableModule,
  PopoverModule,
  StepperModule,
];
@NgModule({
  declarations: [],
  imports: [CommonModule, primeNG],
  exports: [primeNG],
})
export class PrimengModule {}
